const styles = theme => ({
  tabContainer: {
    marginTop: 25,
    padding: '25px 35px 35px 35px',
    overflow: 'hidden',
  },
  error: {
    color: 'red',
  },
  avatarPreview: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  previewText: {
    height: '100%',
    textAlign: 'center',
    cursor: 'pointer',
  },
  number: {
    fontSize: '1rem',
    alignItems: 'normal',
    position: 'relative',
    top: 7,
  },
})

export const activity = theme => ({
  noActivitiesContainer: {
    textAlign: 'center',
  },
  noActivitiesImage: {
    margin: '45px',
  },
  noActivitiesTitle: {
    margin: '0',
    fontSize: '20px',
  },
  noActivitiesSubtitle: {
    color: 'gray',
  },
  activityContainer: {
    margin: '10px 0',
    padding: 15,
    cursor: 'pointer',
    borderRadius: 5,
  },
  activityContent: {
    margin: '0',
    fontSize: '14px',
    color: 'gray',
  },
  activityDate: {
    marginBottom: '0',
    fontSize: '12px',
    color: 'gray',
  },
  boldText: {
    color: 'black',
    fontStyle: 'initial',
  }
})

export const appointments = theme => ({
  container: {
    marginTop: 25,
  },
  titleContainer: {
    height: 36,
    marginBottom: 15,
    display: 'flex',
  },
  title: {
    flex: 1,
    paddingTop: 5,
  },
  message: {
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  noAppointmentsContainer: {
    textAlign: 'center',
  },
  noAppointmentsImage: {
    margin: '45px',
  },
  noAppointmentsTitle: {
    margin: '0',
    fontSize: '20px',
  },
  noAppointmentsSubtitle: {
    color: 'gray',
  },
  appointmentContainer: {
    margin: '10px 0',
    padding: 15,
    cursor: 'pointer',
    borderRadius: 5,
  },
  appointmentStatus: {
    margin: '0',
    fontSize: '14px',
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  appointmentDescription: {
    margin: '0',
    marginTop: '2px',
    fontSize: '14px',
    color: 'black',
  },
  appointmentDate: {
    marginBottom: '0',
    fontSize: '12px',
    color: 'gray',
  },

})

export const cancelAppointmentDialog = theme => ({
  dialogTitle: {
    textAlign: 'center',
  },
  dialogText: {
    textAlign: 'center',
  },
  dialogButtonContainer: {
    marginTop: 15,
  },
  dialogButton: {
    width: 250,
    background: theme.palette.primary,
  },
})

export const viewAppointmentDialog = theme => ({
  dialog: {
    backgroundColor: theme.palette.background.modal,
  },
  content: {
    padding: 10,
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  subheader: {
    lineHeight: '1rem',
  },
  dialogButtonContainer: {
    marginTop: 15,
    textAlign: 'center',
    '&:first-child': {
      marginTop: 10,
    }
  },
  dialogButton: {
    width: 250,
    background: 'rgba(0,0,0,0.05)',
  },
  centerContainer: {
    maxWidth: 400,
    margin: '0 auto',
    textAlign: 'center',
  },
  comment: {
    width: '100%',
  },
  cursorPointer: {
    cursor: 'pointer',
    margin: '12px',
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/activity/styles.js